<script setup lang="ts">
import srcLocalMarket from '~/assets/images/find-real-estate-agent/local.jpg';
import srcValuation from '~/assets/images/find-real-estate-agent/valuation.jpg';
import srcPrice from '~/assets/images/find-real-estate-agent/price.jpg';
</script>

<template>
  <IadWrapper
    class="bg-neutral-80"
    inner-classes="pt-2xl pb-xl"
  >
    <IadTitle
      :text="$t(`agent.search_form.content.title`)"
      variant="large"
      tag="h2"
      class="pb-l"
    />
    <IadScrollable>
      <FindAgentContentCard
        :src="srcLocalMarket"
        :title="$t(`agent.search_form.content.local_market.title`)"
        :description="$t(`agent.search_form.content.local_market.description`)"
        :alt="$t('agent.search_form.content.local_market.alt_text')"
      />
      <FindAgentContentCard
        :src="srcValuation"
        :title="$t(`agent.search_form.content.availability.title`)"
        :description="$t(`agent.search_form.content.availability.description`)"
        :alt="$t('agent.search_form.content.availability.alt_text')"
      />
      <FindAgentContentCard
        :src="srcPrice"
        :title="$t(`agent.search_form.content.price.title`)"
        :description="$t(`agent.search_form.content.price.description`)"
        :alt="$t('agent.search_form.content.price.alt_text')"
      />
    </IadScrollable>
  </IadWrapper>
</template>
